export interface NearbyArea {
	groupId: number;
	name: string;
	distanceMeters: number;
}

export enum NearbyAreasPlatform {
	Desktop = "Desktop",
	Mobile = "Mobile",
}
